<template>
  <rexEChartsVue ref="chart" :option="option" :autoResize="true" />
</template>

<script>
import rexEChartsVue from '../../rex-components/rex-eCharts.vue';

export default {
  name: 'ChartBar',
  components: { rexEChartsVue },
  props: {
    data: {},
    intervalTime: {},
    item: {}
  },
  methods: {
    resize() {
      const chart = this.$refs.chart;
      chart.myChart.resize();
    }
  },
  computed: {
    option() {
      const keys = Object.keys(this.data || {}).filter(
        i => Array.isArray(this.data[i]) && this.data[i].length
      );
      // eslint-disable-next-line no-unused-vars
      const temp = keys.map((i, index) => {
        return {
          data: this.data[i].map((item, itemIndex) => [
            this.intervalTime[itemIndex],
            item
          ]),
          name: i,
          type: 'bar',
          symbol: 'none',
          barMaxWidth: 10,
          stack: '总量',
          lineStyle: {
            width: 1.5,
            type: 'dotted'
          }
        };
      });
      let color = [];
      switch (keys.length) {
        case 2:
          color = ['#61a8e7', '#19792B'];
          break;
        case 1:
          color = ['#61a8e7'];
          break;
        default:
          color = [
            '#61a8e7',
            '#19792B',
            '#FFCC55',
            '#FE6984',
            '#A0A7E6',
            '#c23531',
            '#2f4554',
            '#61a0a8',
            '#d48265',
            '#91c7ae',
            '#749f83',
            '#ca8622',
            '#bda29a',
            '#6e7074',
            '#546570',
            '#c4ccd3'
          ];
          break;
      }
      return {
        color,
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgb(41 ,161 ,152)',
          borderColor: 'rgb(41 ,161 ,152)',
          textStyle: {
            fontSize: 13,
            color: 'rgb(2, 43, 54)'
          },
          enterable: true,
          extraCssText:
            'max-height: 300px; overflow: scroll box-shadow: 0 0.188rem 0.375rem 0px text-align:left;border-color:none;'
          // -o-box-shadow: 0 3px 6px 0px $shadow;
          // -webkit-box-shadow: 0 3px 6px 0px $shadow;
          // -moz-box-shadow: 0 3px 6px 0px $shadow;
          // formatter: '{a}: {c1}<br />Time: {b0} '
        },
        legend: {
          type: 'scroll',
          show: keys.length === 1 ? false : true,
          icon:
            'path://M18.736000061035156,5.369999885559082l-0.8700008392333984,-0.869999885559082L7.039999961853027,15.324999809265137l-4.670000076293945,-4.668999671936035l-0.869999885559082,0.869999885559082l5.539999961853027,5.539999961853027Z',

          top: 0,
          left: 0,
          itemWidth: 12,
          textStyle: {
            color: 'rgb(253 ,246 ,227)'
          },
          pageIconColor: 'rgb(253 ,246 ,227)',
          pageTextStyle: { color: 'rgb(253 ,246 ,227)' }
        },
        grid: {
          top: keys.length === 1 ? 15 : 40,
          left: 20,
          right: 0,
          bottom: 25,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: this.item.labels.xAxis,
          nameLocation: 'middle',
          axisTick: {
            lineStyle: { color: '#c1c5ca41' },
            alignWithLabel: true
          },
          splitLine: { show: false },
          axisLine: { lineStyle: { color: 'rgba(0,0,0,0)' } },
          axisLabel: { color: '#9da5b2', fontSize: '6' },
          nameTextStyle: {
            color: 'rgb(255 ,255 ,255)',
            fontSize: 8,
            align: 'center',
            borderType: 'solid',
            padding: [17, 17, 17, 17]
          }
        },
        yAxis: {
          type: 'value',
          name: this.item.labels.yAxis,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#c1c5ca41', type: 'dashed' } },
          axisLabel: { color: '#9da5b2', fontSize: '8' },
          nameLocation: 'middle',
          nameTextStyle: {
            align: 'center',
            fontSize: 8,
            color: 'rgb(255 ,255 ,255)',
            // verticalAlign: 'bottom',
            borderType: 'solid',
            padding: [0, 0, 15, 0]
          }
        },
        series: temp
      };
    }
  }
};
</script>
